import { Group, Stack, UnstyledButton, createStyles } from '@mantine/core';
import type {
	ApiGetQueryChartsResponse,
	QueryMetadata,
} from '@repo/api-codegen';
import { Selector } from '@repo/common/components';
import { SelectorTarget } from '@repo/common/components/Selectors/SelectorTarget';
import { SelectType } from '@repo/common/components/Selectors/types';
import { Icon, Text, Title } from '@repo/foundations';
import QueryGraph from '../../../pages/QueryPage/components/QueryGraph';
import { graphOptions } from '../constants';

const useStyles = createStyles((theme) => ({
	frame: {
		borderRadius: theme.other.borderRadius.md,
		border: `1px solid ${theme.other.getColor('border/secondary/default')}`,
		background: theme.other.getColor('surface/primary/default'),
		padding: theme.spacing.md,
		width: '600px',
	},
}));

export function QueryAnalytics({
	charts,
	metadata,
	isOpen,
	setIsOpen,
	selectedGraph,
	setSelectedGraph,
}: {
	charts: ApiGetQueryChartsResponse | undefined;
	metadata: QueryMetadata | undefined;
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
	selectedGraph: {
		field: 'total_runs' | 'total_runtime' | 'average_runtime';
		title: string;
	};
	setSelectedGraph: (graph: {
		field: 'total_runs' | 'total_runtime' | 'average_runtime';
		title: string;
	}) => void;
}) {
	const { classes } = useStyles();
	return (
		<Stack spacing="xl">
			<UnstyledButton onClick={() => setIsOpen(!isOpen)}>
				<Group spacing="xs" align="center">
					<Title order={3}>Analytics</Title>
					<Icon name={isOpen ? 'chevronDown' : 'chevronRight'} />
				</Group>
			</UnstyledButton>
			{isOpen && (
				<Stack className={classes.frame}>
					<Group>
						<Selector
							initialValue={[selectedGraph.field]}
							getItems={() =>
								Promise.resolve(
									graphOptions.map((item) => ({
										label: item.title,
										value: item.field,
									}))
								)
							}
							onChange={(value) =>
								setSelectedGraph(
									graphOptions.find((item) => item.field === value[0]) ??
										graphOptions[0]
								)
							}
							selectType={SelectType.Single}
							disableSearch
						>
							<SelectorTarget variant="tertiary" size="lg">
								<Group spacing="2xs">
									<Text size="sm">
										{
											graphOptions.find(
												(item) => item.field === selectedGraph.field
											)?.title
										}
									</Text>
								</Group>
							</SelectorTarget>
						</Selector>
					</Group>

					<QueryGraph
						data={charts}
						field={selectedGraph.field}
						title={selectedGraph.title}
						metric={metadata?.[selectedGraph.field]}
						units={'ms'}
						inCard
					/>
				</Stack>
			)}
		</Stack>
	);
}
